/**
 * @generated SignedSource<<8d6503ea29aaad49cad9020d351a4201>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
export type UpdateNoteStreamInfoInput = {
  clientMutationId?: string | null;
  description?: string | null;
  name?: string | null;
  notestreamId: string;
};
export type DetailsStreamUpdateMutation$variables = {
  input: UpdateNoteStreamInfoInput;
};
export type DetailsStreamUpdateMutation$data = {
  readonly updateNotestreamInfo: {
    readonly edge: {
      readonly node: {
        readonly description: string;
        readonly displayName: string;
        readonly id: string;
        readonly type: NoteStreamType;
      } | null;
    } | null;
  } | null;
};
export type DetailsStreamUpdateMutation = {
  response: DetailsStreamUpdateMutation$data;
  variables: DetailsStreamUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateNoteStreamInfoPayload",
    "kind": "LinkedField",
    "name": "updateNotestreamInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteStreamEdge",
        "kind": "LinkedField",
        "name": "edge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DetailsStreamUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DetailsStreamUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9a264aee5f19e32f45db478b2c9c89ec",
    "id": null,
    "metadata": {},
    "name": "DetailsStreamUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation DetailsStreamUpdateMutation(\n  $input: UpdateNoteStreamInfoInput!\n) {\n  updateNotestreamInfo(input: $input) {\n    edge {\n      node {\n        id\n        displayName\n        type\n        description\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c89b2674cc0bd75d7402443da74f4f5";

export default node;
